<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'SYSTEM-CONFIGURATIONS'" [breadcrumb]="''" [count]="count"
  icon="fa-cogs">
</app-breadcrumb>
<kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
  <kendo-tabstrip-tab title="{{ 'SETTINGS' | translate }}" [selected]="true">
    <ng-template kendoTabContent>
      <div class="row mt-2">
        <div class="col-sm-12">
          <div class="inputWithIcon inputWithIcon-search float-right d-flex">
            <app-advanced-mode id="settingGridAdvancedSwitch" [storageKey]="'settings-list'"
              (collapsibleToggle)="enableAdvanced=$event">
            </app-advanced-mode>
            <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
              (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" [disabled]="!loaded" />
            <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
          </div>
        </div>
      </div>
      <div class="mt-3 ml-3 mr-3">
        <kendo-grid [data]="view.gridData" [loading]="view.loading" [navigable]="true"
          [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
          [pageSize]="view.state.take" [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort"
          [filterable]="enableAdvanced" [filter]="view.state.filter" [groupable]="enableAdvanced" [group]="view.groups"
          [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true"
          [reorderable]="enableAdvanced" (groupChange)="groupChange($event)"
          (dataStateChange)="dataStateChange($event)">
          <kendo-grid-column field="name" [width]="40" title="{{ 'NAME' | translate }}"></kendo-grid-column>
          <kendo-grid-column field="value" [width]="30" title="{{ 'VALUE' | translate }}"></kendo-grid-column>
          <kendo-grid-column class="text-center" field="perOrganization" [width]="10"
            title="{{ 'SETTING-PER-ORGANIZATION' | translate }}" filter="boolean">
            <ng-template kendoGridCellTemplate let-dataItem>
              <i *ngIf="dataItem.perOrganization" class="fas fa-check"
                [ngClass]="{'per-organization-used': dataItem.organizations.length > 0}"></i>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="lastModifiedBy" [width]="15" title="{{ 'LAST-MODIFIED-BY' | translate }}">
          </kendo-grid-column>
          <kendo-grid-column field="lastModifiedOn" [width]="15" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
            filter="date" format="{0:g}"></kendo-grid-column>
          <kendo-grid-command-column [width]="10" title="{{ 'ACTIONS' | translate }}" class="text-center">
            <ng-template kendoGridCellTemplate let-dataItem>
              <i *ngIf="editVisible(dataItem)" class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}"
                (click)="editHandler(dataItem['id'])">
              </i>
            </ng-template>
          </kendo-grid-command-column>
          <kendo-grid-messages noRecords="{{ (view.loading ? 'LOADING' : 'NO-SYSTEM-SETTINGS') | translate }}">
          </kendo-grid-messages>
        </kendo-grid>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="{{ 'ROLES-ACCESS' | translate }}" *ngIf="loaded && !view.loading">
    <ng-template kendoTabContent>
      <kendo-grid class="ml-3 mr-3 mt-3" [data]="rolesView.gridData" [loading]="rolesView.loading" [pageable]="false"
        [navigable]="true" [pageSize]="rolesView.state.take" [skip]="rolesView.state.skip" [sortable]="true"
        [sort]="rolesView.state.sort" [filterable]="false" [filter]="rolesView.state.filter" [groupable]="false"
        [selectable]="{ mode: 'single' }" [columnMenu]="false" [resizable]="true" [reorderable]="false"
        (dataStateChange)="rolesDataStateChange($event)">
        <ng-template kendoGridToolbarTemplate [position]="'top'">
          <button type="button" kendoGridExcelCommand [disabled]="count === 0">
            {{'EXPORT-TO-EXCEL' | translate }}<i class="fal fa-file-excel" style="width: 15px;color:white"></i>
          </button>
        </ng-template>
        <kendo-grid-column *ngFor="let col of rolesColumnsConfig" [field]="col.field" [title]="col.title"
          [width]="col.width" [filterable]="false" [sortable]="col.sortable" [headerClass]="'text-center'"
          [hidden]="col.hidden !== undefined ? col.hidden : false" [class]="col.class !== undefined ? col.class : ''">
          <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
            <label [ngClass]="{'pointer': column.field !== 'name'}" for="{{column.field}}">{{column.title}}
              <input *ngIf="column.field !== 'name'" id="{{column.field}}" class="ml-1" type="checkbox" kendoCheckBox
                (change)="changeRoles(column.field)" [(ngModel)]="rolesTitleSelection[column.field]" />
            </label>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field !== 'name'">
            <input type="checkbox" [(ngModel)]="dataItem.roles[col.field]" [checked]="dataItem.roles[col.field]"
              kendoCheckBox (change)="rolesUpdated = true;" *ngIf="isValidSettingForRole(dataItem.key, col.field)" />
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-excel fileName="RolesAccess.xlsx" [fetchData]="allData"></kendo-grid-excel>
      </kendo-grid>
      <div class="row m-3 float-right" *ngIf="rolesUpdated">
        <button class="k-button mr-2" (click)="onCancelRolesChanges($event)">{{ 'CANCEL' | translate }}</button>
        <button class="k-button" (click)="onSaveRolesChanges($event)" [disabled]="!rolesUpdated">{{ 'SAVE' | translate
          }}</button>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>

<!--Edit form-->
<app-setting-edit [model]="editDataItem" [channels]="channels" [assessments]="assessments"
  [programLeadsUsers]="programLeadsUsers" [allUsers]="allUsers" [isPerOrganization]="isPerOrganization"
  (save)="saveChangesHandler($event)" (cancelling)="cancelChangesHandler()">
</app-setting-edit>